import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { isPhone } from "@cadmakers-ui/core";
import {
  CMApp,
  Navbar,
  AppIcon,
  Nav,
  Icon,
  NavTabbedDropdown,
  NotificationsPanel,
  Search,
  NavDropdown
} from "cm-layout";
import { User } from "oidc-client";
import { Icon as UIIcon } from "@cadmakers-ui/icons";
import queryString from "query-string";
import { authService } from "../../Auth";
import { BreadcrumbData, SearchBarContainer } from "../../Layout";
import { appPaths, IAppState, roleService } from "../../Common";
import { Role } from "../../Common/Constants/roleEnums";
import { Company } from "../../Company/Models/Company";
import { useUserDetails } from "../../User";
import { Breadcrumbs, SetBreadcrumb } from "./Breadcrumbs";
import { Application } from "../../App";
import { Topic } from "../../Topic/Models/Topic";
import { SearchbarContext } from "../../Search/SearchbarContext";

// import UserIcon from "../../Layout/Images/user.jpg";

type Props = {
  user?: User;
  company?: Company;
  activeApp?: Application;
  activeTopic?: Topic;
  onClickAddFeedback: () => void;
  breadcrumbs: BreadcrumbData[];
};

export const FeedbackNavbar = (props: Props) => {
  const { user, company, breadcrumbs } = props;

  const history = useHistory();
  const location = useLocation();

  const { userDetails } = useUserDetails();

  const email = user ? user.profile.email : "";
  const username = user ? user.profile.username : "";
  const displayName = userDetails ? userDetails.name : "";
  const companyShortName = company ? company.shortName : null;
  const isCMAdmin = useMemo(() => {
    return user ? roleService.isUserInRole(user, Role.CMAdmin) : false;
  }, [user]);
  const isAdmin = useMemo(() => {
    return user ? roleService.isUserInRole(user, Role.Admin) || isCMAdmin : false;
  }, [user, isCMAdmin]);

  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);

  const toggleDropdownCallback = () => {};

  const navigateTo = (path: string) => {
    history.push(path);
  };

  const onClickCreateFeedback = () => {
    const queryArgs = {
      type: location.pathname.includes("/bugreports") ? "bug" : "feature"
    };

    const stringified = queryString.stringify(queryArgs);

    navigateTo(`${appPaths.feedback.submitFeedback}?${stringified}`);
  };

  const breadcrumbData: BreadcrumbData[] = useSelector((state: IAppState) => state.app.breadcrumbs);

  return (
    <>
      <Navbar>
        <Navbar.Toggle
          username={email || ""}
          displayName={displayName}
          role="User"
          // TODO fix profile image
          // profileImage={UserIcon}
          mobileIcon={<Icon icon="menu" path={null} crossOrigin={null} />}
        />
        {!isPhone && (
          <Navbar.Brand>
            <Link to="/">
              <AppIcon />
            </Link>
          </Navbar.Brand>
        )}

        <Breadcrumbs />
        {/* <Search placeholder="Search..." /> */}
        <SearchbarContext.Consumer>
          {context => <SearchBarContainer setReloadFeedback={context.setReloadFeedback} />}
        </SearchbarContext.Consumer>
        <Navbar.Collapse>
          <Nav>
            <NavDropdown
              open={isDropdownOpen}
              onToggle={() => {
                setIsDropdownOpen(!isDropdownOpen);
              }}
            >
              <NavDropdown.Toggle icon={<Icon icon="plus" path={null} crossOrigin={null} />} />

              <NavDropdown.Menu>
                <NavDropdown.Item
                  onClick={() => {
                    setIsDropdownOpen(false);
                    props.onClickAddFeedback();
                  }}
                >
                  Create New Feedback
                </NavDropdown.Item>
              </NavDropdown.Menu>
            </NavDropdown>

            {/* <NavTabbedDropdown
              name="Notifications"
              icon={<Icon icon="notification" />}
              defaultActiveKey="0"
            >
              <NavTabbedDropdown.TabList>
                <NavTabbedDropdown.Tab title="Notifications" eventKey="0">
                  <Icon icon="notification" />
                </NavTabbedDropdown.Tab>
                <NavTabbedDropdown.Tab title="History" eventKey="1">
                  <Icon icon="history" />
                </NavTabbedDropdown.Tab>
              </NavTabbedDropdown.TabList>
              <NavTabbedDropdown.TabPanel eventKey="0">
                <NotificationsPanel notifications={[]} onClearAll={() => {}} onViewAll={() => {}} />
              </NavTabbedDropdown.TabPanel>
              <NavTabbedDropdown.TabPanel eventKey="1"></NavTabbedDropdown.TabPanel>
            </NavTabbedDropdown> */}
            <Nav.Item
              state="collapsed"
              name="My Profile"
              icon={<UIIcon appName="GeneralLayout" assetName="GENERAL_F_UserM" />}
              onClick={() => navigateTo(appPaths.user.root.replace(":username", username))}
            />
            <Nav.Item
              state="collapsed"
              name="My Preferences"
              icon={<UIIcon appName="GeneralLayout" assetName="GENERAL_L_Settings" />}
              onClick={() => navigateTo(appPaths.user.settings.replace(":username", username))}
            />
            {isAdmin && companyShortName && (
              <Nav.Item
                state="collapsed"
                name="Company Settings"
                icon={<UIIcon appName="GeneralLayout" assetName="GENERAL_L_Company" />}
                onClick={() =>
                  navigateTo(appPaths.company.settings.replace(":shortname", companyShortName))
                }
              />
            )}
            {isCMAdmin && (
              <Nav.Item
                state="collapsed"
                name="CM Admin Settings"
                icon={<UIIcon appName="GeneralLayout" assetName="GENERAL_L_Lock" />}
                onClick={() => navigateTo(appPaths.app.admin.replace(":id", "CMF"))}
              />
            )}
            <Nav.Item
              state="collapsed"
              name="Logout"
              icon={<Icon icon="sign-out" path={null} crossOrigin={null} />}
              onClick={() => authService.signOut()}
            />
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      {breadcrumbData.map(breadCrumbItem => {
        return <SetBreadcrumb breadCrumbKey={breadCrumbItem.key} {...breadCrumbItem} />;
      })}
    </>
  );
};
